import { Box, Typography } from "@mui/material";

import HeroCarousel from "../../Talent/Card/HeaderCarousel/HeroCarousel";
import { heroImages } from "../../Talent/Card/HeaderCarousel/heroImages";
// Suit cards
import { useGetAllCard } from "../../../../services/api/card.api";

import LiveEventsList from "../../../CloverLiveEvents/LiveEventList";
import FeaturedEventCardTN from "../../Talent/Card/Featured_Card/FeaturedEventCardTN";
import Featured from "./Featured";
const ExplorePage = () => {
  return (
    <Box sx={{ pb: 4 }}>
      <HeroCarousel images={heroImages} />
    </Box>
  );
};

export default function UserTaasnetpage() {
  // ------------------ HOOKS ------------------
  const { data: suitCardResponse, isLoading } = useGetAllCard({
    key: ["taas-cards"],
  });

  // ------------------ Early Returns ------------------
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6"> Loading suit cards...</Typography>
      </Box>
    );
  }

  if (!suitCardResponse?.data) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6">No suit cards found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          // py: { xs: 6, md: 10 },
        }}
      >
        <Box sx={{ padding: 0, width: "100%" }}>
          <Typography
            variant="h4"
            fontWeight={700}
            textAlign="center"
            sx={{
              mb: 6,
              color: "text.secondary",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
            }}
          ></Typography>
          <ExplorePage />
          <Featured
            title="Taas Talk"
            bannerImage="https://images.unsplash.com/photo-1602743297108-4c9061884285?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            startTime="2025-07-10T17:00:00"
            endTime="2025-07-10T18:00:00"
            guests={[
              { name: "John Doe", avatar: "https://i.pravatar.cc/300?img=1" },
              { name: "Jane Smith", avatar: "https://i.pravatar.cc/300?img=2" },
            ]}
            isLive={true}
            isReplay={false}
            onActionClick={() => console.log("Join Now clicked")}
          />

          <FeaturedEventCardTN />
          {/* <SuitSelectorWithSection isTalnetAsUser={!!currentProfile} /> */}
          {/* <TrendingCard isTalnetAsUser={!!currentProfile} /> */}
          {/* <SuitSelectorWithSectionAvailableNOw
            isTalnetAsUser={!!currentProfile}
          /> */}
          <LiveEventsList />
          {/* <CoffeeCallSection /> */}
        </Box>
      </Box>
    </>
  );
}
